// extracted by mini-css-extract-plugin
module.exports = {"AuthNavContainer":"AuthNav_AuthNavContainer__34-PO","AuthNavLink":"AuthNav_AuthNavLink__3Yl5l","activeAuthNavLink":"AuthNav_activeAuthNavLink__2O6u3"};